<template>
  <div>
    <div
      v-for="(seller, idx) in sellers"
      :key="idx"
      outlined
      class="mb-4"
    >
      <v-row align="start">
        <v-col class="pt-1">
          <template
            v-if="seller.roles"
          >
            <b>{{
            seller.roles?.map(role => {
                const roles = {
                  ORGANIZATION: 'Yritys',
                  ORGANIZATION_SIGNER: 'Yrityksen edustaja',
                  SIGNER: 'Myyjä',
                  ESTATE: 'Kuolinpesä',
                  ESTATE_SIGNER: 'Kuolinpesän edustaja',
                }

                return roles[role];
              }).join(', ')
            }}</b>
            <br>
          </template>

          <template v-if="seller.organization">
            <participant-detail
              title="Nimi"
              :value="seller.organization.name"
            />

            <participant-detail
              title="VAT-tunnus"
              :value="seller.organization.businessId"
            />
          </template>

          <template v-else>
            <participant-detail title="Etunimi" :value="seller.person?.firstName"/>

            <participant-detail title="Sukunimi" :value="seller.person?.lastName"/>

            <participant-detail
              title="Henkilötunnus"
              :value="seller.person.socialSecurityNumber"
            />

            <participant-detail
              v-if="!seller.roles?.some(role => role === 'ESTATE')"
              title="Sähköposti"
              :value="seller.person.email"
            />
          </template>

          <participant-detail
            v-if="seller.roles?.some(role => role === 'ORGANIZATION_SIGNER')"
            title="Edustaa yrityksiä"
            :value="seller.businessIds?.map(
            businessId => getCompanyName(businessId)).join(', ')"
          />

          <participant-detail
            v-if="seller.roles?.some(role => role === 'ESTATE_SIGNER')"
            title="Edustaa kuolinpesiä"
            :value="seller.estateSocialSecurityNumbers.map(ssn => getEstateName(ssn)).join(', ')"
          />

          <participant-detail
            v-if="seller.realtorPayment?.amountInCents"
            title="Maksaa välityspalkkiota"
            :value="$filters.currency(seller.realtorPayment?.amountInCents / 100)"
          />

          <template
            v-if="['ORGANIZATION', 'SIGNER', 'ESTATE']
              .some(role => (seller.roles || []).includes(role))"
          >
            Pankki: <b
              v-if="
              seller.person?.bankBusinessId || seller.bankBusinessId"
            >
              {{ getBankName(seller.person?.bankBusinessId ||
              seller.bankBusinessId) }}</b>
            <span v-else class="red--text">
              Ei valittu
              <v-icon
                color="red"
                size="16"
              >
                error
              </v-icon>
            </span>
          </template>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    'participant-detail': () => import('@/components/DIAS/DIASParticipantDetail.vue'),
  },
  props: {
    sellers: {
      type: Array,
      default: () => [],
    },
    banks: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    estates() {
      return this.sellers.filter(seller => seller.roles.includes('ESTATE')) || [];
    },
  },
  methods: {
    getBankName(businessId) {
      const bank = this.banks.find(b => b.businessId === businessId);

      if (bank) {
        return `${bank.name} (${bank.groupName})`;
      }

      return businessId;
    },

    getCompanyName(businessId) {
      const company = this.sellers.find(e => e.organization?.businessId === businessId);

      return company?.organization?.name || '';
    },

    getEstateName(estateSsn) {
      const estateObj = this.estates.find(e => e.person.socialSecurityNumber === estateSsn);

      return `${estateObj.person.firstName} ${estateObj.person.lastName}`;
    },
  },
};
</script>
